import React, {
  useEffect,
  useRef,
  ReactElement,
  PropsWithChildren,
} from "react";
import mainMobile from "../../assets/img/main-mobile.png";
import shadowMoile from "../../assets/img/shadow.png";
import game from "../../assets/img/slider/game.png";
import prepaid from "../../assets/img/slider/prepaid.png";
import travel from "../../assets/img/slider/travel.png";
import tablet from "../../assets/img/slider/tablet.png";
import prepaidMobileImg from "../../assets/img/services/prePaid/h-prepaid.png";
import travelMobileImg from "../../assets/img/services/travel/h-travel.png";
import gamepinMobileImg from "../../assets/img/services/gamePin/h-gamepin.png";
import billpaymentMobileImg from "../../assets/img/services/billPayment/h-billpayment.png";
import { ReactComponent as CirculeIcon } from "../../assets/img/svgicons/circle.svg";
import {
  ArrowRightIcon,
  ArrowTopIcon,
  AppleStoreWhiteIcon,
  PlayStoreMultiColorIcon,
  AndroidIconGreen,
  PrepaidIcon,
  BillPaymentIcon,
  GamePinLargeIcon,
  TravelIcon,
} from "../../assets/img/svgicons";
import card from "../../assets/img/card.png";
import useSectionStyles, {
  SectionBuilderClasses,
} from "../Home/SectionBuilder/styles";
import useHomeStyles, { HomeClasses } from "./styles";
import { Swiper, SwiperSlide } from "swiper/react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import DownloadIconBuilder from "../../components/DownloadIconBuilder";
import { useTranslation } from "react-i18next";
import { servicesData } from "../../translation";
import { Link } from "react-router-dom";
import SwiperCore, { Navigation } from "swiper";

gsap.registerPlugin(ScrollTrigger);
SwiperCore.use([Navigation]);

export type HomeProps = {};

export type SectionBuilderProps = {
  sectionDirection?: "rtl" | "ltr";
  sectionMargin?: Array<number>;
  contentBoxPadding?: Array<number>;
};

function Home({
  sectionDirection = "rtl",
  sectionMargin = [],
  contentBoxPadding = [],
}: PropsWithChildren<SectionBuilderProps>): ReactElement {
  let width = window.innerWidth;
  let breakpoint = 768;

  const servicesDataEn: any = servicesData.en;
  const servicesDataTr: any = servicesData.tr;
  let [activeServices, setActiveServices] = React.useState(servicesDataEn);
  let [shadowMobileImageLoaded, setShadowMobileImageLoaded] = React.useState(
    false
  );

  const useStyles: HomeClasses = useHomeStyles({
    shadowMobileImageLoaded,
    width,
    breakpoint,
  });

  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const mounted = useRef();
  useEffect(() => {
    if (!mounted.current) {
      if (lang === "en") {
        setActiveServices(servicesDataEn);
      } else {
        setActiveServices(servicesDataTr);
      }
    }
  }, [lang, servicesDataEn, servicesDataTr]);

  const SectionStyles: SectionBuilderClasses = useSectionStyles({
    sectionDirection,
    contentBoxPadding,
    sectionMargin,
  });

  const sliderSectionTitleTextRef = useRef<HTMLHeadingElement>(null);
  const swiperSlideImgRef = useRef<HTMLImageElement>(null);
  const swiperSliderRef = useRef<HTMLDivElement>(null);
  // Start Section Ref
  const sectionOneRef = useRef<HTMLElement>(null);
  const sectionOneContentBoxRef = useRef<HTMLDivElement>(null);
  const sectionOneContentIconRef = useRef<HTMLElement>(null);
  const sectionOneContentTitleRef = useRef<HTMLHeadingElement>(null);
  const sectionOneContentDescRef = useRef<HTMLHeadingElement>(null);
  const sectionOneContentDetailsLinkRef = useRef<HTMLAnchorElement>(null);
  const sectionOneImgLogoRef = useRef<HTMLImageElement>(null);
  const sectionOneFaqTitleRef = useRef<HTMLDivElement>(null);
  const sectionOneFaqListRef = useRef<HTMLUListElement>(null);

  // Section 2
  const sectionTwoRef = useRef<HTMLElement>(null);
  const sectionTwoImgLogoRef = useRef<HTMLImageElement>(null);
  const sectionTwoContentBoxRef = useRef<HTMLDivElement>(null);
  const sectionTwoContentIconRef = useRef<HTMLElement>(null);
  const sectionTwoContentTitleRef = useRef<HTMLHeadingElement>(null);
  const sectionTwoContentDescRef = useRef<HTMLHeadingElement>(null);
  const sectionTwoContentDetailsLinkRef = useRef<HTMLAnchorElement>(null);
  const sectionTwoFaqTitleRef = useRef<HTMLDivElement>(null);
  const sectionTwoFaqListRef = useRef<HTMLUListElement>(null);

  // Section 3
  const sectionThreeRef = useRef<HTMLElement>(null);
  const sectionThreeImgLogoRef = useRef<HTMLImageElement>(null);
  const sectionThreeContentBoxRef = useRef<HTMLDivElement>(null);
  const sectionThreeContentIconRef = useRef<HTMLElement>(null);
  const sectionThreeContentTitleRef = useRef<HTMLHeadingElement>(null);
  const sectionThreeContentDescRef = useRef<HTMLHeadingElement>(null);
  const sectionThreeContentDetailsLinkRef = useRef<HTMLAnchorElement>(null);
  const sectionThreeFaqTitleRef = useRef<HTMLDivElement>(null);
  const sectionThreeFaqListRef = useRef<HTMLUListElement>(null);

  // Section 4
  const sectionFourRef = useRef<HTMLElement>(null);
  const sectionFourImgLogoRef = useRef<HTMLImageElement>(null);
  const sectionFourContentBoxRef = useRef<HTMLDivElement>(null);
  const sectionFourContentIconRef = useRef<HTMLElement>(null);
  const sectionFourContentTitleRef = useRef<HTMLHeadingElement>(null);
  const sectionFourContentDescRef = useRef<HTMLHeadingElement>(null);
  const sectionFourContentDetailsLinkRef = useRef<HTMLAnchorElement>(null);
  const sectionFourFaqTitleRef = useRef<HTMLDivElement>(null);
  const sectionFourFaqListRef = useRef<HTMLUListElement>(null);

  // End Section Ref

  const mainCirculeImageRef = useRef<SVGSVGElement>(null);
  const mainCardImageRef = useRef<HTMLImageElement>(null);
  const mainMoileImageRef = useRef<HTMLImageElement>(null);
  const mainMoileImageShadowRef = useRef<HTMLImageElement>(null);

  const mainTitleRef = useRef<HTMLHeadingElement>(null);
  const mainDescRef = useRef<HTMLHeadingElement>(null);
  // const mainInputBoxRef = useRef<HTMLDivElement>(null);
  // const getTheAppRef = useRef<HTMLDivElement>(null);
  // const mainNoticeRef = useRef<HTMLDivElement>(null);
  const backToTopRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    document.title = "SuperPay";
    window.scrollTo(0, 0);

    if (
      mainCirculeImageRef &&
      mainCirculeImageRef.current &&
      mainCardImageRef &&
      mainCardImageRef.current &&
      mainMoileImageRef &&
      mainMoileImageRef.current &&
      mainMoileImageShadowRef &&
      mainMoileImageShadowRef.current &&
      mainTitleRef &&
      mainTitleRef.current &&
      mainDescRef &&
      mainDescRef.current &&
      // mainInputBoxRef &&
      // mainInputBoxRef.current &&
      // getTheAppRef &&
      // getTheAppRef.current &&
      backToTopRef &&
      backToTopRef.current &&
      // mainNoticeRef &&
      // mainNoticeRef.current &&
      sliderSectionTitleTextRef &&
      sliderSectionTitleTextRef.current &&
      swiperSlideImgRef &&
      swiperSlideImgRef.current &&
      swiperSliderRef &&
      swiperSliderRef.current &&
      // ... Section 1 ...
      sectionOneRef &&
      sectionOneRef.current &&
      sectionOneContentBoxRef &&
      sectionOneContentBoxRef.current &&
      sectionOneContentIconRef &&
      sectionOneContentIconRef.current &&
      sectionOneContentTitleRef &&
      sectionOneContentTitleRef.current &&
      sectionOneContentDescRef &&
      sectionOneContentDescRef.current &&
      sectionOneContentDetailsLinkRef &&
      sectionOneContentDetailsLinkRef.current &&
      sectionOneImgLogoRef &&
      sectionOneImgLogoRef.current &&
      sectionOneFaqTitleRef &&
      sectionOneFaqListRef.current &&
      // ... Section 2 ...
      sectionTwoRef &&
      sectionTwoRef.current &&
      sectionTwoImgLogoRef &&
      sectionTwoImgLogoRef.current &&
      sectionTwoContentBoxRef &&
      sectionTwoContentBoxRef.current &&
      sectionTwoContentIconRef &&
      sectionTwoContentIconRef.current &&
      sectionTwoContentTitleRef &&
      sectionTwoContentTitleRef.current &&
      sectionTwoContentDescRef &&
      sectionTwoContentDescRef.current &&
      sectionTwoContentDetailsLinkRef &&
      sectionTwoContentDetailsLinkRef.current &&
      sectionTwoFaqTitleRef &&
      sectionTwoFaqListRef.current &&
      // ... Section 3 ...
      sectionThreeRef &&
      sectionThreeRef.current &&
      sectionThreeImgLogoRef &&
      sectionThreeImgLogoRef.current &&
      sectionThreeContentBoxRef &&
      sectionThreeContentBoxRef.current &&
      sectionThreeContentIconRef &&
      sectionThreeContentIconRef.current &&
      sectionThreeContentTitleRef &&
      sectionThreeContentTitleRef.current &&
      sectionThreeContentDescRef &&
      sectionThreeContentDescRef.current &&
      sectionThreeContentDetailsLinkRef &&
      sectionThreeContentDetailsLinkRef.current &&
      sectionThreeFaqTitleRef &&
      sectionThreeFaqListRef.current &&
      // ... Section 4 ...
      sectionFourRef &&
      sectionFourRef.current &&
      sectionFourImgLogoRef &&
      sectionFourImgLogoRef.current &&
      sectionFourContentBoxRef &&
      sectionFourContentBoxRef.current &&
      sectionFourContentIconRef &&
      sectionFourContentIconRef.current &&
      sectionFourContentTitleRef &&
      sectionFourContentTitleRef.current &&
      sectionFourContentDescRef &&
      sectionFourContentDescRef.current &&
      sectionFourContentDetailsLinkRef &&
      sectionFourContentDetailsLinkRef.current &&
      sectionFourFaqTitleRef &&
      sectionFourFaqListRef.current
    ) {
      // back to top
      let backToTopAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: backToTopRef.current,
          start: "top 0",
          end: "bottom bottom",
          toggleActions: "pause play pause reverse",
        },
      });
      backToTopAnimation.from(backToTopRef.current, {
        x: 500 + 100,
        duration: 1.2,
        opacity: 0,
      });
      // .....
      // Section 1 Animation -------------
      // image logo
      let imageSectionAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionOneRef.current,
          // markers: true,
          start: "top center",
          // end: "bottom bottom",
          toggleActions: "play compelete reverse none",
        },
      });
      imageSectionAnimation.from(sectionOneImgLogoRef.current, {
        opacity: 0,
        scale: 1.5,
        duration: 1.8,
      });

      // content box
      let contentBoxSectionAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionOneRef.current,
          // markers: true,
          start: "top center",
          // end: "bottom bottom",
          toggleActions: "play compelete reverse none",
        },
      });
      contentBoxSectionAnimation.from(sectionOneContentBoxRef.current, {
        opacity: 0,
        y: 100,
        duration: 1.5,
      });

      // icon
      let iconSectionAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionOneContentIconRef.current,
          start: "top center",
          end: "bottom 60%",
          toggleActions: "pause play pause reverse",
        },
      });
      iconSectionAnimation.to(sectionOneContentIconRef.current, {
        opacity: 1,
        duration: 0.5,
      });
      // title
      let titleSectionAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionOneRef.current,
          start: "top center",
          end: "bottom 60%",
          toggleActions: "play play pause reverse",
        },
      });
      titleSectionAnimation.from(sectionOneContentTitleRef.current, {
        opacity: 0,
        delay: 0.3,
        duration: 0.5,
      });
      // description
      let descSectionAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionOneRef.current,
          start: "top center",
          end: "bottom 60%",
          toggleActions: "play play pause reverse",
        },
      });
      descSectionAnimation.from(sectionOneContentDescRef.current, {
        opacity: 0,
        delay: 1,
        duration: 1.5,
      });
      // link box
      let linkSectionAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionOneRef.current,
          start: "top center",
          end: "bottom 60%",
          toggleActions: "play play pause reverse",
        },
      });
      linkSectionAnimation.from(sectionOneContentDetailsLinkRef.current, {
        opacity: 0,
        delay: 1,
        duration: 1.5,
      });
      // faq list
      let faqTitleSectionAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionOneRef.current,
          start: "top center",
          end: "bottom 60%",
          toggleActions: "play play pause reverse",
        },
      });
      faqTitleSectionAnimation.from(sectionOneFaqTitleRef.current, {
        opacity: 0,
        delay: 1,
        duration: 1.5,
      });
      let faqListSectionAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionOneRef.current,
          start: "top center",
          end: "bottom 60%",
          toggleActions: "play play pause reverse",
        },
      });
      faqListSectionAnimation.from(sectionOneFaqListRef.current, {
        opacity: 0,
        duration: 1.5,
        delay: 1,
      });

      // Section 2 Animation -------------
      let imageSectionTwoAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionTwoRef.current,
          // markers: true,
          start: "top center",
          // end: "bottom bottom",
          toggleActions: "play compelete reverse none",
        },
      });
      imageSectionTwoAnimation.from(sectionTwoImgLogoRef.current, {
        x: 700,
        y: 500,
        duration: 1.4,
        opacity: 0,
      });
      // content box
      let contentBoxSectionTwoAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionTwoRef.current,
          // markers: true,
          start: "top center",
          // end: "bottom bottom",
          toggleActions: "play compelete reverse none",
        },
      });
      contentBoxSectionTwoAnimation.from(sectionTwoContentBoxRef.current, {
        opacity: 0,
        y: 100,
        duration: 1.5,
      });

      // icon
      let iconSectionTwoAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionTwoContentBoxRef.current,
          start: "top center",
          end: "bottom 60%",
          toggleActions: "play compelete reverse none",
        },
      });
      iconSectionTwoAnimation.to(sectionTwoContentIconRef.current, {
        opacity: 1,
        duration: 0.5,
      });
      // title
      let titleSectionTwoAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionTwoRef.current,
          start: "top center",
          end: "bottom 60%",
          toggleActions: "play compelete reverse none",
        },
      });
      titleSectionTwoAnimation.from(sectionTwoContentTitleRef.current, {
        opacity: 0,
        delay: 0.3,
        duration: 1.5,
      });
      // description
      let descSectionTwoAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionTwoRef.current,
          start: "top center",
          end: "bottom 60%",
          toggleActions: "play play pause reverse",
        },
      });
      descSectionTwoAnimation.from(sectionTwoContentDescRef.current, {
        opacity: 0,
        delay: 0.6,
        duration: 1.5,
      });
      // link box
      let linkSectionTwoAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionTwoRef.current,
          start: "top center",
          end: "bottom 60%",
          toggleActions: "play play pause reverse",
        },
      });
      linkSectionTwoAnimation.from(sectionTwoContentDetailsLinkRef.current, {
        opacity: 0,
        delay: 0.8,
        duration: 1.5,
      });

      // faq list
      let faqTitleSectionTwoAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionTwoRef.current,
          start: "top center",
          end: "bottom 60%",
          toggleActions: "play play pause reverse",
        },
      });
      faqTitleSectionTwoAnimation.from(sectionTwoFaqTitleRef.current, {
        opacity: 0,
        delay: 1,
        duration: 1.5,
      });
      let faqListSectionTwoAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionTwoRef.current,
          start: "top center",
          end: "bottom 60%",
          toggleActions: "play play pause reverse",
        },
      });
      faqListSectionTwoAnimation.from(sectionTwoFaqListRef.current, {
        opacity: 0,
        delay: 1,
        duration: 1.5,
      });
      // Section 3 Animation -------------
      let imageSectionThreeAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionThreeImgLogoRef.current,
          // markers: true,
          start: "top bottom",
          toggleActions: "play compelete reverse none",
        },
      });
      imageSectionThreeAnimation.from(sectionThreeImgLogoRef.current, {
        x: -700,
        y: 500,
        duration: 1.4,
        opacity: 0,
        delay: 0.2,
      });

      // content box
      let contentBoxSectionThreeAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionThreeRef.current,
          // markers: true,
          start: "top 500px",
          end: "bottom center",
          toggleActions: "play compelete reverse none",
        },
      });
      contentBoxSectionThreeAnimation.from(sectionThreeContentBoxRef.current, {
        opacity: 0,
        y: 100,
        duration: 1.4,
        delay: 1,
      });

      // icon
      let iconSectionThreeAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionThreeRef.current,
          start: "top center",
          // end: "bottom 60%",
          toggleActions: "play play pause reverse",
        },
      });
      iconSectionThreeAnimation.to(sectionThreeContentIconRef.current, {
        opacity: 1,
        duration: 0.5,
      });
      // title
      let titleSectionThreeAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionThreeRef.current,
          start: "top center",
          end: "bottom 60%",
          toggleActions: "play play pause reverse",
        },
      });
      titleSectionThreeAnimation.from(sectionThreeContentTitleRef.current, {
        opacity: 0,
        delay: 0.3,
        duration: 1.5,
      });
      // description
      let descSectionThreeAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionThreeRef.current,
          start: "top center",
          end: "bottom 60%",
          toggleActions: "play play pause reverse",
        },
      });
      descSectionThreeAnimation.from(sectionThreeContentDescRef.current, {
        opacity: 0,
        delay: 0.6,
        duration: 1.5,
      });
      // link box
      let linkSectionThreeAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionThreeRef.current,
          start: "top center",
          end: "bottom 60%",
          toggleActions: "play play pause reverse",
        },
      });
      linkSectionThreeAnimation.from(
        sectionThreeContentDetailsLinkRef.current,
        {
          opacity: 0,
          delay: 0.8,
          duration: 1.5,
        }
      );
      // faq list
      let faqTitleSectionThreeAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionThreeRef.current,
          start: "top center",
          end: "bottom 60%",
          toggleActions: "play play pause reverse",
        },
      });
      faqTitleSectionThreeAnimation.from(sectionThreeFaqTitleRef.current, {
        opacity: 0,
        delay: 1,
        duration: 1.5,
      });
      let faqListSectionThreeAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionThreeRef.current,
          start: "top center",
          end: "bottom 60%",
          toggleActions: "play play pause reverse",
        },
      });
      faqListSectionThreeAnimation.from(sectionThreeFaqListRef.current, {
        opacity: 0,
        duration: 1.5,
        delay: 1,
      });

      // Section 4 Animation -------------
      let imageSectionFourAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionFourImgLogoRef.current,
          // markers: true,
          start: "top bottom",
          toggleActions: "play compelete reverse none",
        },
      });
      imageSectionFourAnimation.from(sectionFourImgLogoRef.current, {
        x: 700,
        y: 500,
        duration: 1.4,
        opacity: 0,
        delay: 0.1,
      });

      // content box
      let contentBoxSectionFourAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionFourRef.current,
          // markers: true,
          start: "top 500px",
          end: "bottom center",
          toggleActions: "play compelete reverse none",
        },
      });
      contentBoxSectionFourAnimation.from(sectionFourContentBoxRef.current, {
        opacity: 0,
        y: 100,
        duration: 1.4,
      });

      // icon
      let iconSectionFourAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionFourRef.current,
          start: "top center",
          // end: "bottom 60%",
          toggleActions: "play play pause reverse",
        },
      });
      iconSectionFourAnimation.to(sectionFourContentIconRef.current, {
        opacity: 1,
        duration: 0.5,
      });
      // title
      let titleSectionFourAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionFourRef.current,
          start: "top center",
          end: "bottom 60%",
          toggleActions: "play play pause reverse",
        },
      });
      titleSectionFourAnimation.from(sectionFourContentTitleRef.current, {
        opacity: 0,
        delay: 0.3,
        duration: 1.5,
      });
      // description
      let descSectionFourAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionFourRef.current,
          start: "top center",
          end: "bottom 60%",
          toggleActions: "play play pause reverse",
        },
      });
      descSectionFourAnimation.from(sectionFourContentDescRef.current, {
        opacity: 0,
        delay: 0.6,
        duration: 1.5,
      });
      // link box
      let linkSectionFourAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionFourRef.current,
          start: "top center",
          end: "bottom 60%",
          toggleActions: "play play pause reverse",
        },
      });
      linkSectionFourAnimation.from(sectionThreeContentDetailsLinkRef.current, {
        opacity: 0,
        delay: 0.8,
        duration: 1.5,
      });

      // faq list
      let faqTitleSectionFourAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionFourRef.current,
          start: "top center",
          end: "bottom 60%",
          toggleActions: "play play pause reverse",
        },
      });
      faqTitleSectionFourAnimation.from(sectionFourFaqTitleRef.current, {
        opacity: 0,
        delay: 0.5,
        duration: 1.5,
      });
      let faqListSectionFourAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: sectionFourRef.current,
          start: "top center",
          end: "bottom 60%",
          toggleActions: "play play pause reverse",
        },
      });
      faqListSectionFourAnimation.from(sectionFourFaqListRef.current, {
        opacity: 0,
        delay: 0.5,
        duration: 1.5,
      });

      // .....
      // circle image
      let circleImageAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: mainCirculeImageRef.current,
          start: "top 0%",
          end: "bottom bottom",
          toggleActions: "pause play pause reverse",
        },
      });
      circleImageAnimation.to(mainCirculeImageRef.current, {
        x: 300,
        y: -400,
        duration: 1.8,
        scale: 0,
      });
      // card image
      let cardImageAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: mainCardImageRef.current,
          start: "top 200px",
          end: "bottom bottom",
          toggleActions: "pause play pause reverse",
        },
      });
      cardImageAnimation.to(mainCardImageRef.current, {
        x: 300,
        y: -450,
        duration: 1.8,
        rotate: 100,
      });
      // mobile image
      let mobileImageAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: mainMoileImageRef.current,
          start: "top 90px",
          end: "bottom bottom",
          toggleActions: "pause play pause reverse",
        },
      });
      mobileImageAnimation.to(mainMoileImageRef.current, {
        x: 500 + 100,
        duration: 1.2,
        opacity: 0,
      });
      // o
      let mobileImageShadowAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: mainMoileImageShadowRef.current,
          start: "top 90px",
          end: "bottom bottom",
          toggleActions: "pause play pause reverse",
        },
      });
      mobileImageShadowAnimation.to(mainMoileImageShadowRef.current, {
        x: 500 + 100,
        duration: 1.2,
        opacity: 0,
      });
      // Title
      let titleAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: mainTitleRef.current,
          start: "top 18%",
          end: "bottom bottom",
          toggleActions: "pause play pause reverse",
        },
      });
      titleAnimation.to(mainTitleRef.current, {
        x: -800,
        duration: 1,
        opacity: 0,
      });
      // Desc
      let descAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: mainDescRef.current,
          start: "top 250px",
          end: "bottom bottom",
          toggleActions: "pause play pause reverse",
        },
      });
      descAnimation.to(mainDescRef.current, {
        x: -800,
        duration: 1.3,
        opacity: 0,
      });
      // Input Box
      // let inputBoxAnimation = gsap.timeline({
      //   scrollTrigger: {
      //     trigger: mainInputBoxRef.current,
      //     start: "top 350px",
      //     end: "bottom bottom",
      //     toggleActions: "pause play pause reverse",
      //   },
      // });
      // inputBoxAnimation.to(mainInputBoxRef.current, {
      //   x: -800,
      //   delay: 0.2,
      //   duration: 1.6,
      //   opacity: 0,
      // });
      // let getTheAppRefAnimation = gsap.timeline({
      //   scrollTrigger: {
      //     trigger: getTheAppRef.current,
      //     start: "top 350px",
      //     end: "bottom bottom",
      //     toggleActions: "pause play pause reverse",
      //   },
      // });
      // getTheAppRefAnimation.to(getTheAppRef.current, {
      //   x: -800,
      //   delay: 0.2,
      //   duration: 1.6,
      //   opacity: 0,
      // });
      // Notice
      // let noticeAnimation = gsap.timeline({
      //   scrollTrigger: {
      //     trigger: mainNoticeRef.current,
      //     start: "top 480px",
      //     end: "bottom bottom",
      //     toggleActions: "pause play pause reverse",
      //   },
      // });
      // noticeAnimation.to(mainNoticeRef.current, {
      //   x: -800,
      //   delay: 0.3,
      //   duration: 3.8,
      //   opacity: 0,
      // });
      // Slider Text Top
      gsap.to(sliderSectionTitleTextRef.current, {
        opacity: 1,
        duration: 1.2,
        scrollTrigger: {
          trigger: sliderSectionTitleTextRef.current,
          // markers: true,
          start: "top center",
          end: "bottom",
        },
      });
      // Slider
      gsap.from(swiperSliderRef.current, {
        x: -600,
        duration: 1.3,
      });
      gsap.from(swiperSlideImgRef.current, {});
    }
  }, []);

  const goToTopPageHandler = () => {
    window.scroll({ top: 0, behavior: "smooth" });
  };

  const checkFullLoadedImgShadowMobile = () => {
    setTimeout(() => {
      setShadowMobileImageLoaded(true);
    }, 300);
  };

  const downloadApplication = (url: string) => {
    window.location.href = url;
  };

  return (
    <React.Fragment>
      <button
        onClick={goToTopPageHandler}
        className={useStyles.backToTopPage}
        ref={backToTopRef}
      >
        <ArrowTopIcon width="18" style={{ opacity: "0.8" }} />
      </button>
      <section className={useStyles.mainSection}>
        <div className={useStyles.mainContainer}>
          <div className={useStyles.mainWrapper}>
            <div className={useStyles.mainContentBox}>
              <h2 className={useStyles.mainContentTitle} ref={mainTitleRef}>
                {t("mainTitle")}
                {/* <span className={useStyles.mainContentTitleSuperpay}>Pay</span> */}
              </h2>
              <h4 className={useStyles.mainContentDesc} ref={mainDescRef}>
                {t("mainDesc")}
              </h4>
              {/* <div className={useStyles.getAppLabel} ref={getTheAppRef}>
                {t("downloadAppLabel")}
              </div>
              <div
                className={useStyles.mainContentStartedBox}
                ref={mainInputBoxRef}
              >
                <DownloadIconBuilder
                  icon={<PlayStoreMultiColorIcon width="24" height="30" />}
                  descText={"GET IN THE"}
                  mainText={"GooglePlay"}
                  padding="8px 22px 8px 10px"
                  bgColor="#212227"
                />
                <div
                  className={useStyles.divider}
                  style={
                    width <= breakpoint ? { width: "5px" } : { width: "10px" }
                  }
                ></div>
                <DownloadIconBuilder
                  icon={<AppleStoreWhiteIcon width="22" height="30" />}
                  descText={"Available on the"}
                  mainText={"App Store"}
                  padding="8px 35px 8px 10px"
                  bgColor="#212227"
                />
                <div
                  className={useStyles.divider}
                  style={
                    width <= breakpoint ? { width: "5px" } : { width: "10px" }
                  }
                ></div>
                <DownloadIconBuilder
                  link="#"
                  icon={<AndroidIconGreen width="26" height="26" />}
                  descText={"Directly Download"}
                  mainText={"For Free"}
                  padding="10px 26px 10px 12px"
                  bgColor="#212227"
                /> 
              </div>*/}
            </div>
            <div className={useStyles.mainImageBox}>
              <CirculeIcon width="400px" ref={mainCirculeImageRef} />
              <img
                src={card}
                alt=""
                className={useStyles.mainImgeCard}
                ref={mainCardImageRef}
              />
              <div className="mainImgBoxes">
                <img
                  src={shadowMoile}
                  onLoad={checkFullLoadedImgShadowMobile}
                  alt=""
                  className={` ${useStyles.mainImgeMobileShadow}`}
                  ref={mainMoileImageShadowRef}
                />
                <img
                  src={mainMobile}
                  alt=""
                  className={useStyles.mainImgeMobile}
                  ref={mainMoileImageRef}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Section Slider */}
      <section id="services" className={SectionStyles.sliderSectionTitle}>
        <h4
          className={SectionStyles.sliderSectionTitleText}
          ref={sliderSectionTitleTextRef}
        >
          {t("hedlineSlider")}
        </h4>
        <div ref={swiperSliderRef}>
          <Swiper
            spaceBetween={0}
            slidesPerView={4}
            navigation
            className={useStyles.swiperContainer}
          >
            <SwiperSlide className={useStyles.swiperSlide}>
              <Link to="/services/game-pin">
                <img
                  src={game}
                  alt=""
                  className={useStyles.swiperSlideImage}
                  ref={swiperSlideImgRef}
                />
              </Link>
              <Link
                to="/services/game-pin"
                className={SectionStyles.contentDetailsLink}
                ref={sectionOneContentDetailsLinkRef}
              >
                <span className={useStyles.swiperSlideText}>
                  {t("gamePinService")}
                </span>
                <ArrowRightIcon width="15px" />
              </Link>
            </SwiperSlide>
            <SwiperSlide className={useStyles.swiperSlide}>
              <Link to="/services/prepaid">
                <img
                  src={prepaid}
                  alt=""
                  className={useStyles.swiperSlideImage}
                  ref={swiperSlideImgRef}
                />
              </Link>
              <Link
                to="/services/prepaid"
                className={SectionStyles.contentDetailsLink}
                ref={sectionOneContentDetailsLinkRef}
              >
                <span className={useStyles.swiperSlideText}>
                  {t("prepaidService")}
                </span>
                <ArrowRightIcon width="15px" />
              </Link>
            </SwiperSlide>
            <SwiperSlide className={useStyles.swiperSlide}>
              <Link to="/services/travel">
                <img
                  src={travel}
                  alt=""
                  className={useStyles.swiperSlideImage}
                  ref={swiperSlideImgRef}
                />
              </Link>
              <Link
                to="/services/travel"
                className={SectionStyles.contentDetailsLink}
                ref={sectionOneContentDetailsLinkRef}
              >
                <span className={useStyles.swiperSlideText}>
                  {t("travelService")}
                </span>
                <ArrowRightIcon width="15px" />
              </Link>
            </SwiperSlide>
            <SwiperSlide className={useStyles.swiperSlide}>
              <Link to="/services/bill-payment">
                <img
                  src={tablet}
                  alt=""
                  className={useStyles.swiperSlideImage}
                  ref={swiperSlideImgRef}
                />
              </Link>
              <Link
                to="/services/bill-payment"
                className={SectionStyles.contentDetailsLink}
                ref={sectionOneContentDetailsLinkRef}
              >
                <span className={useStyles.swiperSlideText}>
                  {t("billPaymentService")}
                </span>
                <ArrowRightIcon width="15px" />
              </Link>
            </SwiperSlide>
          </Swiper>
        </div>
      </section>
      <div className={useStyles.container}>
        {/* Section 1 */}
        <section
          className={SectionStyles.section}
          style={{ margin: "90px 0 0 0" }}
          ref={sectionOneRef}
        >
          <div className={SectionStyles.wrapper}>
            <div>
              <div>
                <img
                  src={prepaidMobileImg}
                  alt=""
                  className={SectionStyles.imgLogo}
                  ref={sectionOneImgLogoRef}
                />
              </div>
            </div>
            <div>
              <div
                className={SectionStyles.contentBox}
                ref={sectionOneContentBoxRef}
                style={{ padding: "0 0 0 105px" }}
              >
                <i
                  className={SectionStyles.contentIconBox}
                  ref={sectionOneContentIconRef}
                >
                  <PrepaidIcon width="36px" height="45px" />
                </i>
                <h2
                  className={SectionStyles.contentTitle}
                  ref={sectionOneContentTitleRef}
                >
                  {activeServices ? console.log(activeServices) : ""}
                  {activeServices.prepaid.title}
                </h2>
                <h4
                  className={SectionStyles.contentDesc}
                  ref={sectionOneContentDescRef}
                >
                  {activeServices.prepaid.text}
                </h4>
                <div
                  className={useStyles.spContentFaqTitle}
                  ref={sectionOneFaqTitleRef}
                >
                  {activeServices.prepaid.benefitsTitle}
                </div>
                <ul
                  className={useStyles.spContentFaqList}
                  ref={sectionOneFaqListRef}
                >
                  {activeServices.prepaid.benefits
                    ? activeServices.prepaid.benefits.map((item: any) => {
                        return <li key={item.id}>{item.text}</li>;
                      })
                    : ""}
                </ul>
                <Link
                  to="/services/prepaid"
                  className={SectionStyles.contentDetailsLink}
                  ref={sectionOneContentDetailsLinkRef}
                >
                  <span className={SectionStyles.contentDetailsText}>
                    {t("learnMoreText")}
                  </span>
                  <ArrowRightIcon width="15px" />
                </Link>
              </div>
            </div>
          </div>
        </section>
        {/* Section 2 */}
        <section
          className={SectionStyles.section}
          style={{ margin: "80px 0 0 0" }}
          ref={sectionTwoRef}
        >
          <div
            className={SectionStyles.wrapper}
            style={{ flexDirection: "row-reverse", padding: "0 0 0 50px" }}
          >
            <div>
              <div>
                <img
                  src={travelMobileImg}
                  alt=""
                  className={SectionStyles.imgLogo}
                  ref={sectionTwoImgLogoRef}
                />
              </div>
            </div>
            <div>
              <div
                className={SectionStyles.contentBox}
                ref={sectionTwoContentBoxRef}
              >
                <i
                  className={SectionStyles.contentIconBox}
                  ref={sectionTwoContentIconRef}
                >
                  <TravelIcon width="50px" height="50px" />
                </i>
                <h2
                  className={SectionStyles.contentTitle}
                  ref={sectionTwoContentTitleRef}
                  style={{ maxWidth: "500px" }}
                >
                  {activeServices.travel.title}
                </h2>
                <h4
                  className={SectionStyles.contentDesc}
                  ref={sectionTwoContentDescRef}
                >
                  {activeServices.travel.text}
                </h4>

                <div
                  className={useStyles.spContentFaqTitle}
                  ref={sectionTwoFaqTitleRef}
                >
                  {activeServices.travel.benefitsTitle}
                </div>
                <ul
                  className={useStyles.spContentFaqList}
                  ref={sectionTwoFaqListRef}
                >
                  {activeServices.travel.benefits
                    ? activeServices.travel.benefits.map((item: any) => {
                        return <li key={item.id}>{item.text}</li>;
                      })
                    : ""}
                </ul>
                <Link
                  to="/services/travel"
                  className={SectionStyles.contentDetailsLink}
                  ref={sectionTwoContentDetailsLinkRef}
                >
                  <span className={SectionStyles.contentDetailsText}>
                    {t("learnMoreText")}
                  </span>
                  <ArrowRightIcon width="15px" />
                </Link>
              </div>
            </div>
          </div>
        </section>
        {/* Section 3 */}
        <section
          className={SectionStyles.section}
          style={{ margin: "80px 0 0 0" }}
          ref={sectionThreeRef}
        >
          <div className={SectionStyles.wrapper}>
            <div>
              <div>
                <img
                  src={gamepinMobileImg}
                  alt=""
                  className={SectionStyles.imgLogo}
                  ref={sectionThreeImgLogoRef}
                />
              </div>
            </div>
            <div>
              <div
                className={SectionStyles.contentBox}
                ref={sectionThreeContentBoxRef}
                style={{ padding: "0 0 0 105px" }}
              >
                <i
                  className={SectionStyles.contentIconBox}
                  ref={sectionThreeContentIconRef}
                >
                  <GamePinLargeIcon width="55px" height="45px" />
                </i>
                <h2
                  className={SectionStyles.contentTitle}
                  ref={sectionThreeContentTitleRef}
                  style={{ marginTop: 5 }}
                >
                  {activeServices.gamePin.title}
                </h2>
                <h4
                  className={SectionStyles.contentDesc}
                  ref={sectionThreeContentDescRef}
                >
                  {activeServices.gamePin.text}
                </h4>

                <div
                  className={useStyles.spContentFaqTitle}
                  ref={sectionThreeFaqTitleRef}
                >
                  {activeServices.gamePin.benefitsTitle}
                </div>
                <ul
                  className={useStyles.spContentFaqList}
                  ref={sectionThreeFaqListRef}
                >
                  {activeServices.gamePin.benefits
                    ? activeServices.gamePin.benefits.map((item: any) => {
                        return <li key={item.id}>{item.text}</li>;
                      })
                    : ""}
                </ul>
                <Link
                  to="/services/game-pin"
                  className={SectionStyles.contentDetailsLink}
                  ref={sectionThreeContentDetailsLinkRef}
                >
                  <span className={SectionStyles.contentDetailsText}>
                    {t("learnMoreText")}
                  </span>
                  <ArrowRightIcon width="15px" />
                </Link>
              </div>
            </div>
          </div>
        </section>
        {/* Section 4 */}
        <section
          className={SectionStyles.section}
          style={{ margin: "80px 0 0 0" }}
          ref={sectionFourRef}
        >
          <div
            className={SectionStyles.wrapper}
            style={{ flexDirection: "row-reverse", padding: "0 0 0 50px" }}
          >
            <div>
              <div>
                <img
                  src={billpaymentMobileImg}
                  alt=""
                  className={SectionStyles.imgLogo}
                  ref={sectionFourImgLogoRef}
                />
              </div>
            </div>
            <div>
              <div
                className={SectionStyles.contentBox}
                ref={sectionFourContentBoxRef}
              >
                <i
                  className={SectionStyles.contentIconBox}
                  ref={sectionFourContentIconRef}
                >
                  <BillPaymentIcon width="40px" height="40px" />
                </i>
                <h2
                  className={SectionStyles.contentTitle}
                  ref={sectionFourContentTitleRef}
                  style={{ maxWidth: "500px" }}
                >
                  {activeServices.billPayment.title}
                </h2>
                <h4
                  className={SectionStyles.contentDesc}
                  ref={sectionFourContentDescRef}
                >
                  {activeServices.billPayment.text}
                </h4>

                <div
                  className={useStyles.spContentFaqTitle}
                  ref={sectionFourFaqTitleRef}
                >
                  {activeServices.billPayment.benefitsTitle}
                </div>
                <ul
                  className={useStyles.spContentFaqList}
                  ref={sectionFourFaqListRef}
                >
                  {activeServices.billPayment.benefits
                    ? activeServices.billPayment.benefits.map((item: any) => {
                        return <li key={item.id}>{item.text}</li>;
                      })
                    : ""}
                </ul>
                <Link
                  to="/services/bill-payment"
                  className={SectionStyles.contentDetailsLink}
                  ref={sectionFourContentDetailsLinkRef}
                >
                  <span className={SectionStyles.contentDetailsText}>
                    {t("learnMoreText")}
                  </span>
                  <ArrowRightIcon width="15px" />
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
}

export default Home;
